import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import dayjs from 'dayjs';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a date string (ISO 8601 or YYYY-MM-DD) to a short readable string.
 * Returns "—" for null/undefined/empty values.
 */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = dayjs(value);
  return d.isValid() ? d.format('DD/MM/YYYY') : value;
}

/**
 * Formats a monetary amount with thousand separators and one decimal place.
 * Uses the runtime locale so the separator matches the user's environment.
 * Examples: 1234567.89 → "1,234,567.9"  |  0 → "0.0"
 */
export function formatAmount(value: number): string {
  return value.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  });
}

/**
 * Formats a number with thousand separators and no decimal places.
 * Examples: 1234567 → "1,234,567"
 */
export function formatNumber(value: number): string {
  return value.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  });
}
